<template>
  <div module-item :class="info.type" v-html="info.value"></div>
</template>

<script>

export default {
  name: 'BasicText',
  props: ['value'],
  computed: {
    info() {
      return this.value;
    },
  },
}
</script>

